export const state = () => {
  return {
    isSubpageOpen: false,
  }
}
export const getters = {
  GET_IS_SUBPAGE_OPEN(state) {
    return state.isSubpageOpen
  },
}

export const mutations = {
  SET_IS_SUBPAGE_OPEN(state, value: boolean) {
    state.isSubpageOpen = value
  },
}
